export default __webpack_public_path__ + "static/media/fnl_newhome_desktop.35867457.jpg";